import React from 'react'
import { Container } from '../../globalStyles'
import {
    FooterContainer,
    FooterTitle,
    FooterDesc
} from './footer.elements'

const Footer = () => {
    return(
        <>
            <FooterContainer>
                <FooterTitle>Started at 19-2-2021</FooterTitle>
                <FooterDesc>M Hadi</FooterDesc>
            </FooterContainer>
        </>
    )
}   

export default Footer;